<div class="row row-sm add-form min">
    <div class="col-lg-12 ">
        <div class="card-body">
            <div class="bc d-flex align-items-center pl-3">
                <div class="ml-2">
                    <h3 class="main-content-label mb-1"><b>
                            Subjects Appeared
                        </b></h3>
                </div>
            </div>

            <div class="row row-sm add-form">
                <h6>{{data.data.ReRgId}} {{data.data.RgName}}</h6>
                <div class="col-sm-12 pl-0">
                    <div>
                        <div class="table-responsive table-container" id="table">
                            <table class="table table-bordered text-nowrap">
                                <thead>
                                    <tr class="text-left">
                                        <th class="f600">
                                            Ty
                                        </th>
                                        <th class="f600">
                                            Sub
                                        </th>
                                        <th class="f600">
                                            Head
                                        </th>
                                        <th class="f600">
                                            MaxMarks
                                        </th>
                                        <th class="f600">
                                            Marks
                                        </th>
                                        <th class="f600">
                                            Grade
                                        </th>
                                        <th class="f600">
                                            Result
                                        </th>
                                        <th class="f600">
                                            Dist
                                        </th>
                                        <th class="f600">
                                            Grace
                                        </th>
                                        <th class="f600">
                                            GP
                                        </th>
                                        <th class="f600">
                                            CR
                                        </th>
                                        <th class="f600">
                                            GP_CR
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="curs">
                                    <!-- *ngFor="let item of examData" [class.selected-row]="item === selectedRow" (click)="selected(item)" -->
                                    <tr *ngFor="let item of subGrid">
                                        <td>{{item.EsType}}</td>
                                        <td>{{item.EmCode}}</td>
                                        <td>{{item.ReSnName}}</td>
                                        <td>{{item.RsMaxMarks}}</td>
                                        <td>{{item.RsMarks}}</td>
                                        <td>{{item.RsGrade}}</td>
                                        <td>{{item.RsResult}}</td>
                                        <td>{{item.RsDistSign}}</td>
                                        <td>{{item.RsGrace}}</td>
                                        <td>{{item.RsGrdPts}}</td>
                                        <td>{{item.RsCredits}}</td>
                                        <td>{{item.RsGP_CR}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">

                    </div>
                    <div class="col-sm-4">
                        <button type="button" [mat-dialog-close]="true"
                            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                <img width="20vh" src="../../assets/img/list.gif" style="margin-right: 7px;">
                                List
                            </span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>